var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-style-preview-wrap",style:(_vm.outerStyle)},[_c('canvas',{ref:"previewCanvas",staticClass:"badge-style-preview-canvas",style:(_vm.canvasDisplayStyle),attrs:{"width":_vm.canvasWidth || 684,"height":_vm.canvasHeight || 366}})])
}
var staticRenderFns = []

export { render, staticRenderFns }